import { ApiUtils } from '@/utils/ApiUtils'
import { resetState } from '@/utils/Storage'

const initialState = () => {
  return {
    loading: false,
    selectedBranch: null,
    selectedBranchIndex: null,
    branches: []
  }
}

export default {
  namespaced: true,
  state: {
    loading: false,
    selectedBranch: null,
    selectedBranchIndex: null,
    branches: []
  },
  mutations: {
    reset: (state) => {
      const s = initialState()
      resetState(state, s);
    },
    setBranches(state, payload) {
      state.branches = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    selectBranch(state, payload) {
      state.selectedBranch =  payload.branch
      state.selectedBranchIndex = payload.index
    },
    saveEditedBranch(state, payload) {
      state.branches[payload.index] = payload.branch
    },
    deleteBranch(state) {
      state.branches.splice(state.selectedBranchIndex, 1)
      state.selectedBranch = null
      state.selectedBranchIndex = null
    }
  },
  actions: {
    async loadBranches(ctx) {
      try {
        await ApiUtils.fetchMe()
        /* eslint-disable */
        const provider = ctx.rootState.currentProvider
        const branches = provider && provider.institution ?
            provider.institution.branch_offices : [];
        ctx.commit('setBranches', branches)
      } catch(error) {
        /* eslint-disable */

      }
    },
    async addNewBranch(ctx, payload) { // sucursal
      const added = await ctx.dispatch('sendBranchToApi', payload)
      if (added.ok) {
        ctx.commit('showSnackBar', 'Sucursal creada', {root: true})
        ctx.commit('setBranches', added.data)
      } else {
        ctx.commit('showSnackBar', added.data && added.data.message || 'Error creando sucursal', {root: true})
      }
      return added.ok
    },
    async editBranch(ctx, payload) { // sucursal
      const edited = await ctx.dispatch('sendBranchToApi', payload)
      if (edited.ok) {
        const index = ctx.state.selectedBranchIndex
        ctx.commit('saveEditedBranch', {index, branch: payload})
        ctx.commit('selectBranch', {index, branch: payload})
        ctx.commit('showSnackBar', 'Cambios guardados correctamente', {root: true})
      } else {
        ctx.commit('showSnackBar', edited.data && edited.data.message || 'Error guardando sucursal', {root: true})
      }
      return edited.ok
    },
    async deleteBranch(ctx, payload) { // sucursal
      try {
        ctx.commit('setLoading', true)
        const deleted = await ApiUtils.makeDelete('provider/branch-office', payload.id)
        if (deleted.ok) {
          ctx.commit('deleteBranch')
          ctx.commit('showSnackBar', 'Sucursal Eliminada', {root: true})
        }
        return deleted.ok
      } catch (error) {

        ctx.commit('showSnackBar', 'Error Eliminando Sucursal', {root: true})
        return false
      } finally {
        ctx.commit('setLoading', false)
      }
    },
    async sendBranchToApi(ctx, payload) {
      const { id, institution } = ctx.rootState.currentProvider
      if (!id) return
      const temp = {
        institution: {
          id: institution.id,
          institution_type_id: institution.institution_type_id,
          name: institution.name,
          branch_offices: [
            payload
          ]
        }
      }
      try {
        ctx.commit('setLoading', true)
        const response = await ApiUtils.makePatch('provider', id, temp)
        const decoded = await response.json()
        if (response.ok) {
          await ApiUtils.fetchMe()
          return {ok: true, data: decoded.result.provider.institution.branch_offices}
        }
        return {ok: false, data: decoded}
      } catch (error) {

        return {ok: false, data: null}
      } finally {
        ctx.commit('setLoading', false)
      }
    }
  },
  getters: {
    getAll: state => state.branches,
    loading: state => state.loading,
    selected: state => {
      return {index: state.selectedBranchIndex, branch: state.selectedBranch}
    }
  }
}
